const DEFAULT_COORDINATES = [37.6156, 55.7522];

export const parseCoordinates = (position?: string): [number, number] => {
    const [lat, lon] = position?.split(' ').map(Number) ?? DEFAULT_COORDINATES;

    return [lat, lon];
};
